import escapeRegExp from './escapeRegExp';

const THOUSANDS_MARK = (/\B(?=(\d{3})+(?!\d))/g);

const defaults = {
  decimalMark: '.',
  thousandsMark: ',',
  digits: 2, // after decimal mark
};

/**
 * Sets the numeric format according to the settings passed in.
 *
 * @param {String} value - the number to format
 * @param {Object} options - settings for input and output values
 * @returns {String}
 */
export default function formatNumber(value, options) {
  options = Object.assign({
    digits: defaults.digits,
    in: {
      decimalMark: defaults.decimalMark,
      thousandsMark: defaults.thousandsMark,
    },
    out: {
      decimalMark: defaults.decimalMark,
      thousandsMark: defaults.thousandsMark,
    },
  }, options);
  if (!value || !value.length) return '';
  const thousands = new RegExp(escapeRegExp(options.in.thousandsMark), 'g'),
    number = value.replace(thousands, '').split(options.in.decimalMark);
  let [integer, decimal = ''] = number;
  if (integer !== '0' && !+integer) return '';
  integer = integer.replace(THOUSANDS_MARK, options.out.thousandsMark);
  decimal = decimal.substring(0, options.digits).trim();
  if (decimal) decimal = options.out.decimalMark + decimal;
  return (integer.trim() + decimal);
}
